<template>
  <!-- 账期调整审批历史记录 -->
  <div class="approve-list-record">
    <a-card style="margin-bottom: 10px">
      <search-view
        :renderItem="TERM_SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>

    <a-card>
      <!-- <div class="text-right">
        <a-button @click="exportTable" type="primary">导出</a-button>
      </div> -->
      <table-view
        bordered
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="SCROLL"
        @handlePagination="handlePagination"
        row-key="key"
      >
        <template v-slot:applyAmount="{ tableRow }">
          <span v-html="$formatAppAmount(tableRow.applyAmount)"></span>
        </template>

        <template v-slot:approveAmount="{ tableRow }">
          <span v-html="$formatAppAmount(tableRow.approveAmount)"></span>
        </template>

        <template v-slot:type="{ tableRow }">
          <span>{{ CREDIT_TYPE_OBJ[tableRow.type] }}</span>
        </template>

        <template v-slot:action="{ tableRow }">
          <a-button type="link" size="small" @click="handleView(tableRow)">
            查看
          </a-button>
        </template>
      </table-view>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import cloneDeep from 'lodash/cloneDeep'
import { TERM_SEARCH_SCHEMA } from './schema'
import { APPROVE_STATUS_COLOR_OBJ, MY_APPROVE_STATUS_OBJ } from './const'
import { CREDIT_TYPE_OBJ } from '../const'
import {
  // getAutoRecordList,
  getApproveRecordList,
  // exportList
} from './api'
import { formatParamDate } from 'utils/util'

export default {
  name: 'approve-list-record',
  data() {
    const initSearchForm = {
      endTime: '',
      startTime: '',
      code: '',
      name: '',
      id: '',
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      TERM_SEARCH_SCHEMA,

      APPROVE_STATUS_COLOR_OBJ,
      MY_APPROVE_STATUS_OBJ,
      CREDIT_TYPE_OBJ,
      initSearchForm,
      searchForm,
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableLoading: false,
      tableData: [],
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          fixed: 'left',
          align: 'center',
        },
        {
          title: '流水号',
          dataIndex: 'id',
          width: 190,
          align: 'left',
        },
        {
          title: '企业名称',
          dataIndex: 'companyName',
          align: 'left',
        },
        {
          title: '企业ID',
          dataIndex: 'companyCode',
          align: 'left',
          width: 130,
        },
        {
          title: '申请人',
          dataIndex: 'applyPerson',
          align: 'left',
          width: 130,
        },
        {
          title: '申请日期',
          dataIndex: 'applyDate',
          align: 'center',
          width: 120,
        },
        {
          title: '审批角色',
          dataIndex: 'applyRole',
          align: 'left',
          width: 180,
        },
        {
          title: '审批时间',
          dataIndex: 'approveDate',
          align: 'center',
          width: 220,
        },
        {
          title: '状态',
          dataIndex: 'statusStr',
          align: 'center',
          width: 100,
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 100,
          fixed: 'right',
        },
      ],
      SCROLL: { x: 1550 },
    }
  },
  mounted() {
    this._getRecordList(this.initSearchForm)
  },
  methods: {
    async _getRecordList(searchForm) {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getApproveRecordList(formData)
        this.pageData.total = total
        this.tableData = records.map(item => {
          item.key = `${item.id}_${item.applyRole}`
          return item
        })
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    handleSearch(data) {
      data = formatParamDate(data, data.applyRangeDate)
      delete data.applyRangeDate
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getRecordList(data)
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getRecordList(this.searchForm)
    },
    handleView(row) {
      const { id, status, companyCode } = row
      this.$router.push({
        path: `/credit-approval/approve/approve-detail-view/${id}`,
        query: {
          type: 1,
          status,
          companyCode,
          auto: true,
        },
      })
    },
    // exportTable() {
    //   const params = {
    //     ...this.searchForm,
    //   }
    //   exportList(params)
    // },
  },
  components: {
    SearchView,
    TableView,
  },
}
</script>

<style></style>
